import React from 'react';
import ProjectHealthPanel from '../components/ProjectHealthPanel';

const ProyectoInfra = () => (
  <div className="page-container fade-in">
    <div className="page-header">
      <div className="page-header-left">
        <h1 className="page-title">Proyectos — Infraestructura</h1>
        <p className="page-subtitle">
          Servidores por rol (API, Web, BD, failover, DNS). Clic en el nombre del proyecto para el detalle completo.
        </p>
      </div>
    </div>
    <ProjectHealthPanel />
  </div>
);

export default ProyectoInfra;
